import { Box } from "@mui/material";
import ArrowLR2 from "assets/icons/filter/arrow_lr2.svg";
import SliderFkdsHorn from "assets/icons/filter/slider_fkds_horn.svg";
import React, { useEffect } from "react";
import { isMobileOnly } from "react-device-detect";

export const SliderCaption = React.memo(
  (props: {
    captionRef: React.RefObject<HTMLDivElement | null>;
    arrowRef: React.RefObject<HTMLDivElement | null>;
    styles: Record<string, string>;
    captionLeft: number | undefined;
    captionRight: number | undefined;
    arrowLeft: number | undefined;
    arrowRight: number | undefined;
    title: string;
    fromCaption: string[];
    toCaption: string[];
    chaseThumb: () => void;
  }) => {
    const { captionRef, arrowRef } = props;

    useEffect(() => {
      const resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          if (entry.target === captionRef.current) {
            props.chaseThumb();
          }

          if (entry.target === arrowRef.current) {
            props.chaseThumb();
          }
        }
      });

      resizeObserver.observe(captionRef.current!);
      resizeObserver.observe(arrowRef.current!);

      return () => {
        resizeObserver.disconnect();
      };
    }, [arrowRef, captionRef, props]);

    return (
      <>
        <Box className={props.styles.caption_box_wrapper}>
          <Box
            ref={captionRef}
            className={`${props.styles.caption_box1} ${
              isMobileOnly ? props.styles.mobileOnly : ""
            }`}
            sx={{
              left: props.captionLeft,
              right: props.captionRight
            }}
          >
            <Box className={props.styles.fkds_slider}>
              <Box className={props.styles.fkds_tit}>{props.title}</Box>
              <span className={`${props.styles.value} ${props.styles.min}`}>
                {props.fromCaption.at(0) ?? ""}
              </span>
              {props.fromCaption.at(1) && (
                <small>{props.fromCaption.at(1)}</small>
              )}
              <img src={ArrowLR2} alt="←→" className={props.styles.arrow} />
              <span className={`${props.styles.value} ${props.styles.max}`}>
                {props.toCaption.at(0) ?? ""}
              </span>
              {props.toCaption.at(1) && <small>{props.toCaption.at(1)}</small>}
            </Box>
          </Box>
          <Box
            className={props.styles.caption_box2}
            ref={arrowRef}
            sx={{
              left: props.arrowLeft,
              right: props.arrowRight
            }}
          >
            <Box className={props.styles.fkds_slider_horn}>
              <img src={SliderFkdsHorn} alt="▼" />
            </Box>
          </Box>
        </Box>
      </>
    );
  }
);
